import { useQuery } from "react-query";
import { AppConstant, KeyConstant } from "@/const";
import { DeviceService } from "@/services";
import { PaginationType } from "@/types/common";

const useDeviceList = (props: Partial<PaginationType>) => {
  const { page, size } = props;
  const { data, isLoading, isError } = useQuery({
    queryKey: [KeyConstant.REACT_QUERY, page, size],
    queryFn: () =>
      DeviceService.getListDevice({
        page: page || 1,
        size: size || AppConstant.DEFAULT_SIZE_PAGE,
        internalF: true,
      }),
    keepPreviousData: true,
    retry: 0,
  });

  const { data: deviceList, ...pagination } = data || {};

  return {
    deviceList: deviceList || [],
    pagination: (pagination as PaginationType) || {},
    isLoading,
    isError,
  };
};

export default useDeviceList;
